import { createAction } from "redux-act";
import { log } from "../../../logging";
/**
 * initialize a download (it may not be started immediately)
 */
export const initDownload = createAction("INIT_DOWNLOAD", (id, urls, modInfo, games) => ({
    id,
    urls,
    modInfo,
    games,
}));
/**
 * set download progress (in percent)
 */
export const downloadProgress = createAction("DOWNLOAD_PROGRESS", (id, received, total, chunks, urls) => ({ id, received, total, chunks, urls }));
export const finalizingProgress = createAction("FINALIZING_PROGRESS", (id, progress) => ({ id, progress }));
/**
 * set/change the file path
 */
export const setDownloadFilePath = createAction("SET_DOWNLOAD_FILEPATH", (id, filePath) => ({ id, filePath }));
/**
 * mark the download as pausable or not
 */
export const setDownloadPausable = createAction("SET_DOWNLOAD_PAUSABLE", (id, pausable) => ({ id, pausable }));
/**
 * mark download as started
 */
export const startDownload = createAction("START_DOWNLOAD", (id) => ({
    id,
}));
/**
 * mark download as finalizing, meaning the file has been downloaded fully,
 * during this phase checksums are calculated for example
 */
export const finalizingDownload = createAction("FINALIZING_DOWNLOAD", (id) => ({ id }));
/**
 * mark download as finished
 */
export const finishDownload = createAction("FINISH_DOWNLOAD", (id, state, failCause) => ({
    id,
    state,
    failCause,
}));
export const setDownloadHash = createAction("SET_DOWNLOAD_HASH", (id, fileMD5) => ({ id, fileMD5 }));
export const setDownloadHashByFile = createAction("SET_DOWNLOAD_HASH_BY_FILE", (fileName, fileMD5, fileSize) => ({
    fileName,
    fileMD5,
    fileSize,
}));
/**
 * mark download paused
 */
export const pauseDownload = createAction("PAUSE_DOWNLOAD", (id, paused, chunks) => ({ id, paused, chunks }));
export const setDownloadInterrupted = createAction("SET_DOWNLOAD_INTERRUPTED", (id, realReceived) => ({ id, realReceived }));
/**
 * remove a download (and associated file if any)
 */
export const removeDownload = createAction("REMOVE_DOWNLOAD", (id) => ({
    id,
}));
export const removeDownloadSilent = createAction("REMOVE_DOWNLOAD_SILENT", (id) => ({ id }));
/**
 * sets the current download speed in bytes/second
 */
export const setDownloadSpeed = createAction("SET_DOWNLOAD_SPEED", (speed) => speed, () => ({ forward: false, scope: "local" }));
export const setDownloadSpeeds = createAction("SET_DOWNLOAD_SPEEDS", (speeds) => speeds);
/**
 * add a file that has been found on disk but where we weren't involved
 * in the download.
 */
export const addLocalDownload = createAction("ADD_LOCAL_DOWNLOAD", (id, game, localPath, fileSize) => ({
    id,
    game,
    localPath,
    fileSize,
}));
export const mergeDownloadModInfo = createAction("MERGE_DOWNLOAD_MODINFO", (id, value) => ({ id, value }));
export const setDownloadModInfo = createAction("SET_DOWNLOAD_MODINFO", (id, key, value) => {
    if (key === "game" && Array.isArray(value)) {
        const err = new Error();
        log("error", "setting invalid gameid", { game: value, stack: err.stack });
        value = value[0];
    }
    return { id, key, value };
});
export const setDownloadInstalled = createAction("SET_DOWNLOAD_INSTALLED", (id, gameId, modId) => ({ id, gameId, modId }));
export const setDownloadTime = createAction("SET_DOWNLOAD_TIME", (id, time) => ({ id, time }));
export const setCompatibleGames = createAction("SET_COMPATIBLE_GAMES", (id, games) => ({ id, games }));
